import { yupResolver } from '@hookform/resolvers/yup';
import React, { useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';
import * as yup from 'yup';
import { DROPOFF } from '../../../interfaces/shipping.interface';
import TextInput from '../../form-controls/TextInput';
import { getRequiredErrorMessage } from '../../../utils/common.utils';

interface Props {
  dropoffs: DROPOFF;
}

const schema = yup.object().shape({
  SenderName: yup.string().required(getRequiredErrorMessage("Sender's Name")),
  SenderCity: yup.string().required(getRequiredErrorMessage("Sender's City")),
  ReceiverName: yup
    .string()
    .required(getRequiredErrorMessage("Receiver's Name")),
  ReceiverAddress: yup
    .string()
    .required(getRequiredErrorMessage("Receiver's Address")),
});

export interface Edit_Dropoff_Inputs {
  SenderName: string;
  SenderCity: string;
  ReceiverName: string;
  ReceiverAddress: string;
}

const EditDropOffForm: React.FC<Props> = ({ dropoffs }) => {
  const { handleSubmit, control, errors, setValue, watch } =
    useForm<Edit_Dropoff_Inputs>({
      resolver: yupResolver(schema),
    });

  useEffect(() => {
    // Update form values when dropoffs prop changes
    setValue('SenderName', dropoffs.SenderName || '');
    setValue('SenderCity', dropoffs.SenderCity || '');
    setValue('ReceiverName', dropoffs.ReceiverName || '');
    setValue('ReceiverAddress', dropoffs.ReceiverAddress || '');
  }, [dropoffs, setValue]);

  const onSubmit = (data: Edit_Dropoff_Inputs) => {
    console.log('here');
  };

  return (
    <form className="w-full" onSubmit={handleSubmit(onSubmit)}>
      <div className="w-full">
        <div className="bg-white rounded-lg p-4 sm:p-10 mb-10">
          <div className="mb-5 w-full">
            <Controller
              name="SenderName"
              control={control}
              defaultValue=""
              render={({ name, value, onChange }) => (
                <TextInput
                  name={name}
                  value={value}
                  className="border-gray-300 border p-3 w-full rounded-xl"
                  id={name}
                  labelClassName="mb-2 ml-2 flex"
                  label="Sender Name"
                  type="text"
                  wrapperClassName="w-full"
                  error={errors['SenderName']}
                  placeholder="Enter sender's name"
                  customChange={onChange}
                />
              )}
            />
          </div>

          <div className="mb-5 w-full">
            <Controller
              name="SenderCity"
              control={control}
              defaultValue=""
              render={({ name, value, onChange }) => (
                <TextInput
                  name={name}
                  value={value}
                  className="border-gray-300 border p-3 w-full rounded-xl"
                  id={name}
                  labelClassName="mb-2 ml-2 flex"
                  label="Sender City"
                  type="text"
                  wrapperClassName="w-full"
                  error={errors['SenderCity']}
                  placeholder="Enter sender's city"
                  customChange={onChange}
                />
              )}
            />
          </div>

          <div className="mb-5 w-full">
            <Controller
              name="ReceiverName"
              control={control}
              defaultValue=""
              render={({ name, value, onChange }) => (
                <TextInput
                  name={name}
                  value={value}
                  className="border-gray-300 border p-3 w-full rounded-xl"
                  id={name}
                  labelClassName="mb-2 ml-2 flex"
                  label="Receiver Name"
                  type="text"
                  wrapperClassName="w-full"
                  error={errors['ReceiverName']}
                  placeholder="Enter receiver's name"
                  customChange={onChange}
                />
              )}
            />
          </div>

          <div className="mb-5 w-full">
            <Controller
              name="ReceiverAddress"
              control={control}
              defaultValue=""
              render={({ name, value, onChange }) => (
                <TextInput
                  name={name}
                  value={value}
                  className="border-gray-300 border p-3 w-full rounded-xl"
                  id={name}
                  labelClassName="mb-2 ml-2 flex"
                  label="Receiver's Address"
                  type="text"
                  wrapperClassName="w-full"
                  error={errors['ReceiverAddress']}
                  placeholder="Enter Receiver's Address"
                  customChange={onChange}
                />
              )}
            />
          </div>

          <div className="flex flex-wrap justify-center">
            <button
              type="submit"
              className="border border-secondary w-full sm:w-auto bg-secondary text-white py-3 px-14 font-bold text-lg rounded"
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </form>
  );
};

export default EditDropOffForm;
